import {
    FETCH_SMS_MANAGEMENT_REQUEST,
    FETCH_SMS_MANAGEMENT_SUCCESS,
    FETCH_SMS_MANAGEMENT_FAILURE,
    FETCH_SMS_MANAGEMENT_BY_ID_REQUEST,
    FETCH_SMS_MANAGEMENT_BY_ID_SUCCESS,
    FETCH_SMS_MANAGEMENT_BY_ID_FAILURE,
    CREATE_SMS_MANAGEMENT_REQUEST,
    CREATE_SMS_MANAGEMENT_SUCCESS,
    CREATE_SMS_MANAGEMENT_FAILURE,
    UPDATE_SMS_MANAGEMENT_REQUEST,
    UPDATE_SMS_MANAGEMENT_SUCCESS,
    UPDATE_SMS_MANAGEMENT_FAILURE,
    DELETE_SMS_MANAGEMENT_REQUEST,
    DELETE_SMS_MANAGEMENT_SUCCESS,
    DELETE_SMS_MANAGEMENT_FAILURE,
} from '../actions/smsManagementActions';

const initialState = {
    lastListParams: { skip: 0, limit: 10 },
    smsManagement: {
        loading: false,
        error: null,
        data: null,
    },
    selectedSmsManagement: {
        data: null,
        loading: false,
        error: null,
    },
    create: {
        loading: false,
        error: null,
        success: false,
    },
    update: {
        loading: false,
        error: null,
        success: false,
    },
    delete: {
        loading: false,
        error: null,
        success: false,
    },
};

const smsManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SMS_MANAGEMENT_REQUEST:
            return {
                ...state,
                lastListParams: action.payload || { skip: 0, limit: 10 },
                smsManagement: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };

        case FETCH_SMS_MANAGEMENT_SUCCESS:
            return {
                ...state,
                smsManagement: {
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };

        case FETCH_SMS_MANAGEMENT_FAILURE:
            return {
                ...state,
                smsManagement: {
                    loading: false,
                    error: action.payload,
                    data: null,
                },
            };

        case FETCH_SMS_MANAGEMENT_BY_ID_REQUEST:
            return {
                ...state,
                selectedSmsManagement: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };

        case FETCH_SMS_MANAGEMENT_BY_ID_SUCCESS:
            return {
                ...state,
                selectedSmsManagement: {
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };

        case FETCH_SMS_MANAGEMENT_BY_ID_FAILURE:
            return {
                ...state,
                selectedSmsManagement: {
                    loading: false,
                    error: action.payload,
                    data: null,
                },
            };

        case CREATE_SMS_MANAGEMENT_REQUEST:
            return {
                ...state,
                create: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case CREATE_SMS_MANAGEMENT_SUCCESS:
            return {
                ...state,
                create: {
                    loading: false,
                    error: null,
                    success: true,
                },
            };

        case CREATE_SMS_MANAGEMENT_FAILURE:
            return {
                ...state,
                create: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case UPDATE_SMS_MANAGEMENT_REQUEST:
            return {
                ...state,
                update: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case UPDATE_SMS_MANAGEMENT_SUCCESS: {
            const updatedSmsManagement = action.payload.sms_management || action.payload;
            const updatedSmsManagementId = updatedSmsManagement?.sms_management_id;

            let updatedData = state.smsManagement.data;
            if (updatedData && updatedSmsManagementId) {
                const records = updatedData?.data?.records || updatedData?.records;
                if (Array.isArray(records)) {
                    const updatedRecords = records.map((record) => {
                        const recordSmsMgmtId = record.sms_management?.sms_management_id;
                        if (recordSmsMgmtId === updatedSmsManagementId) {
                            return { ...record, sms_management: updatedSmsManagement };
                        }
                        return record;
                    });

                    if (updatedData.data) {
                        updatedData = {
                            ...updatedData,
                            data: {
                                ...updatedData.data,
                                records: updatedRecords,
                            },
                        };
                    } else if (updatedData.records) {
                        updatedData = {
                            ...updatedData,
                            records: updatedRecords,
                        };
                    }
                }
            }

            return {
                ...state,
                update: {
                    loading: false,
                    error: null,
                    success: true,
                },
                smsManagement: {
                    ...state.smsManagement,
                    data: updatedData,
                },
            };
        }

        case UPDATE_SMS_MANAGEMENT_FAILURE:
            return {
                ...state,
                update: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case DELETE_SMS_MANAGEMENT_REQUEST:
            return {
                ...state,
                delete: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case DELETE_SMS_MANAGEMENT_SUCCESS: {
            const deletedId = action.payload;
            let updatedData = state.smsManagement.data;

            if (updatedData) {
                const records = updatedData?.data?.records || updatedData?.records;
                if (Array.isArray(records)) {
                    const filteredRecords = records.filter(
                        (record) => record.sms_management?.sms_management_id !== deletedId
                    );

                    if (updatedData.data?.records) {
                        updatedData = {
                            ...updatedData,
                            data: {
                                ...updatedData.data,
                                records: filteredRecords,
                            },
                        };
                    } else if (updatedData.records) {
                        updatedData = {
                            ...updatedData,
                            records: filteredRecords,
                        };
                    }
                }
            }

            return {
                ...state,
                delete: {
                    loading: false,
                    error: null,
                    success: true,
                },
                smsManagement: {
                    ...state.smsManagement,
                    data: updatedData,
                },
            };
        }

        case DELETE_SMS_MANAGEMENT_FAILURE:
            return {
                ...state,
                delete: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        default:
            return state;
    }
};

export default smsManagementReducer;
